<template>
  <el-form :ref="ref" :model="formData" :disabled="block || loading">
    <div class="col-md-12 pa-2 justify-center text-center">
      <div class="row">
        <slot />
      </div>
    </div>

    <ed-alert
      type="warning"
      :message="blockMessage"
      v-if="block && blockMessage"
    />

    <div :class="'col-md-12 pa-0 pt-3 justify-center ' + classFooter">
      <ed-button
        v-if="handlerSave"
        :color="colorButton"
        :label="labelButton"
        :disabled="block"
        @click="validar"
        icon="salvar"
        size="100%"
      />
      <slot name="form-footer" />
    </div>
  </el-form>
</template>

<script>
import EdButton from "./EdButton";
import EdAlert from "./EdAlert";

export default {
  name: "EdForm",
  mixins: [],
  components: { EdButton, EdAlert },
  props: {
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    blockMessage: {
      type: String,
      required: false,
      default: 'Você não tem permissão para acessar essa funcionalidade',
    },
    handlerSave: {
      type: Function,
      required: false,
      default: null,
    },
    labelButton: {
      type: String,
      required: false,
      default: "Salvar",
    },
    colorButton: {
      type: String,
      required: false,
      default: "primary",
    },
    iconButton: {
      type: String,
      required: false,
      default: "fa fa-floppy-o",
    },
    classFooter: {
      type: String,
      default: "text-right",
    },
    recaptcha: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: false,
      default: function(){return {}},
    },
  },
  data() {
    return {
      ref: "form-" + this.$utilidade.randomString(),
      recaptchaKey: process.env.GOOGLE_RECAPTCHA,
      recaptchaId: 1,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  methods: {
    validar() {
      // this.$refs[this.ref].validate((valid) => {
      //   if (!valid) {
      //     this.$root.$dialog.alert("Por favor preencher todos os campos");
      //     return;
      //   }
      // });

      if (this.handlerSave) {
        this.handlerSave();
      }
    },

    resetValidation() {
      this.$refs[this.ref].resetValidation();
    },

    onRecaptchaVerify(ev) {
      this.$emit("recaptcha", ev);
    },

    onRecaptchaError(ev) {
      this.$emit("recaptcha", null);
    },

    onRecaptchaRender(id) {},
  },
  watch: {
    block() {},
    loading() {},
    blockMessage() {},
    recaptchaResponse() {},
    reset() {
      this.resetValidation();
    },
    "formData.recaptcha"() {},
    "$root.$request.getResponse"() {
      let response = this.$root.$request.getResponse;

      if (response && response.status == 503) {
        this.recaptchaId++;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdForm.vue?474110da